import $ from 'domtastic';
import Flickity from 'flickity';

class Gallery {
  constructor() {
    if (!$('.js-flickity')[0]) return;
    const $flickity = $('.js-flickity');
    const hasMultipleImages = Number($flickity.attr('data-num-images')) > 1;

    if (!hasMultipleImages) {
      $flickity.removeClass('js-flickity');
      return;
    }
    this.Flickity = new Flickity('.js-flickity', {
      arrowShape: 'M75.6158378,53.1250621 L6.25,53.1250621 C2.79822031,53.1250621 0,50.3268417 0,46.8750621 C0,43.4232824 2.79822031,40.6250621 6.25,40.6250621 L79.1158378,40.6250621 L45.8374014,10.9121724 C43.262589,8.61323274 43.0389499,4.66227597 45.3378896,2.0874635 C47.6368293,-0.48734897 51.5877861,-0.710988032 54.1625986,1.58795167 L97.9125986,40.6504517 C100.6958,43.1354534 100.6958,47.4896707 97.9125986,49.9746724 L54.1625986,89.0371724 C51.5877861,91.3361121 47.6368293,91.1124731 45.3378896,88.5376606 C43.0389499,85.9628481 43.262589,82.0118914 45.8374014,79.7129517 L75.6158378,53.1250621 Z',
    });
    this.cacheDom();
    this.bindEvents();
  }

  cacheDom() {
    this.$viewport = $('.flickity-viewport');
  }

  bindEvents() {
    this.$viewport.on('mouseenter', () => this.show());
    this.$viewport.on('mouseout', () => this.hide(event.toElement || event.relatedTarget));
  }

  show() {
    this.$viewport.addClass('-hover');
  }

  hide(toElement) {
    const $toElement = $(toElement);
    if ($toElement.closest('.flickity-prev-next-button')[0] || $toElement.hasClass('gallery__cell') || $toElement.closest('.gallery__isolated')[0]) return;
    this.$viewport.removeClass('-hover');
  }
}

export default new Gallery();



// WEBPACK FOOTER //
// ./components/Gallery.js